import TableChatView from "./tablechat_view";
import ModuleBase, { moduleInit, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import EventManager from "../../../../manager/event_manager";
import Utility from "../../../../utility/utility";
import TimeManager from "../../../../manager/time_manager";
import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import NetMsgDataBase from "../../net/net_msg_data_table_base";
import ModelBase from "../../../../framework/core/mvvm/model_base";

const { ccclass, property } = cc._decorator;

enum ChatMsgType {
    voiceMsg = 0,
    shotMsg = 1,
    emojiMsg = 2,
    text = 3,
    gift = 10,
    tmpLeave = 99,
}

@ccclass
@moduleInit("TableChat")
export default class TableChat extends ModuleBase<TableChatView, null> {

    _model: ModelBase = new ModelBase()
    _lastPinTime: number = 0
    protected LastSendChatTime: number = 0

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/public/hall_tablechat';
        this.viewType = TableChatView;
    }

    curTabIndex = 0;

    onInit(data?) {
        this.addEvent();
        this.registMsg()
        this.view.InputRoot.active = false
        this.view.InitContent()
        this.curTabIndex = 0
        this.showMenuByIndex()
        this.ShowCurContent()
        this.CheckImmediatelyHide(data)
    }

    onShow(data?) {
        this.CheckImmediatelyHide(data)
    }

    CheckImmediatelyHide(data) {
        let IsImmediatelyHide = data["IsImmediatelyHide"] || false
        if (IsImmediatelyHide) {
            this.hide()
        }
    }

    addEvent() {
        let self= this
        this._model.subscibeMsgEvent<ProtoPokerRoom.Room.ChatMsgBroadcast>(NetMsgDataBase.ChatNotify, function (protoData) {
            self.onNetMsgChatNotify(protoData)
        })

        this.view.btnClose.node.on('click', this.onClick_btnClose, this);
        this.view.btnSend.node.on('click', this.onClick_Send, this);

        let length = this.view.TabButtonList.length
        for (let i = 0; i < length; i++) {
            let btn = this.view.TabButtonList[i]
            btn.on("click", this.onMenuBtnClick, this)
        }

        let itemparent0 = this.view.itemparent0
        for (let i = 0; i < itemparent0.childrenCount; i++) {
            let Expression = itemparent0.children[i]
            Expression.on("click", this.onClick_Expression, this)
        }
    }

    private onMenuBtnClick(event: cc.Button) {
        Utility.playButtonSound()
        let name = event.node.name
        let curIndex = Number(name)
        if (curIndex != this.curTabIndex) {
            this.curTabIndex = curIndex
            this.showMenuByIndex()
            this.ShowCurContent()
        }
    }

    private showMenuByIndex() {
        let length = this.view.TabButtonList.length
        for (let i = 0; i < length; i++) {
            let btn = this.view.TabButtonList[i]
            let checkMark = btn.getChildByName("checkmark")
            checkMark.active = Number(btn.name) == this.curTabIndex
            let index = Number(btn.name)
            if (index == this.curTabIndex) {
                checkMark.active = true
                if (index == 2) {
                    let self = this
                    this.scheduleOnce(() => {
                        self.view.itemScroll()
                    }, 0.1)
                }
            } else {
                checkMark.active = false
            }
        }
    }

    private onClick_Expression(event: cc.Button) {
        let node: cc.Node = event.node
        let index = node.name.replace("expression", "")
        EventManager.instance.dispatch("tablechat_sendcontent", 1, index)
        this.hide()
    }

    private onClick_Send() {
        Utility.playButtonSound()
        let inputString = this.view.editBox.string
        let maxLen = 20
        if (inputString.length > maxLen) {
            inputString = inputString.substring(0, maxLen)
            this.view.editBox.string = inputString
        }
        if (inputString.length <= 0) {
            ModuleManager.instance.toast("请输入内容")
            return
        }
        EventManager.instance.dispatch("tablechat_sendcontent", 2, inputString)
        this.view.editBox.string = ""
    }

    private onClick_btnClose() {
        Utility.playButtonSound()
        ModuleManager.instance.hideModule("TableChat")
    }

    private ShowCurContent() {
        let ContentList = this.view.ContentList
        for (let i = 0; i < ContentList.length; i++) {
            ContentList[i].active = this.curTabIndex == i
        }
    }

    RefreshRecord(dataArr) {
        this.view.RefreshChatRecord(dataArr)
    }

    private registMsg() {
        this.eventBind("tablechat_RefreshRecord", this.RefreshRecord)
        this.eventBind("tablechat_sendcontent", this.sendChat)
    }


    protected onNetMsgChatNotify(protoData: ProtoPokerRoom.Room.ChatMsgBroadcast) {
        let seatInfo = null//this.getSeatInfoByPlayerId(protoData.playerId)
        if (seatInfo) {
            let chatMsg = protoData.chatMsg
            let data: any = {}
            data["chatContent"] = chatMsg.text
            switch (chatMsg.msgType) {
                case ChatMsgType.text:
                   
                    break
                case ChatMsgType.shotMsg:
                    
                    break
                case ChatMsgType.voiceMsg:

                    return;
                case ChatMsgType.gift:
                   
                    return;
                case ChatMsgType.tmpLeave:
                    
                    return;
                case ChatMsgType.emojiMsg:
                   
                    break;

                default:
                    return;
            }
            // ModuleManager.instance.showModule(ChatShow, "ChatShow", data)
        }
    }


    sendChat(type, content) {
        let AppRunningTime = TimeManager.instance.AppRunningTime
        if (this.LastSendChatTime > 0 && this.LastSendChatTime + 2.6 > AppRunningTime) {
            ModuleManager.instance.toast("对话过于频繁,歇息一会再发吧")
            return
        }
        this.LastSendChatTime = AppRunningTime
        //type: 0:系统文本对话  1:表情对话  2:自己输入的文本 //content :系统文本对话或者表情id或者自己输入的文本的内容
        let chatMsgType = ChatMsgType.shotMsg
        switch (type) {
            case 0:
                chatMsgType = ChatMsgType.shotMsg
                break;
            case 1:
                chatMsgType = ChatMsgType.emojiMsg
                break;
            case 2:
                chatMsgType = ChatMsgType.text
                break;
        }
        this.send_chat_request(chatMsgType, content)
    }

    send_chat_request(chatMsgType: number, text: string){
        let chatmsg: ProtoPokerRoom.Room.IChatMsg = {
            msgType: chatMsgType,
            text: text
        }
        let protoData: ProtoPokerRoom.Room.IChatMsgReq = {
            chatMsg: chatmsg
        }
        this._model.sendMsg(NetMsgDataBase.Chat, protoData)
    }

}